import { useContext } from "react";
import { useApolloClient, useMutation } from "react-apollo";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { LogoutDocument, LogoutMutation, LogoutMutationVariables } from "../../graphql/components";
import { notAllowConciliador } from "../../redux/actions/allowAction";
import configureStore from "../../redux/configureStore";
import Routes from "../../utils/routes";
import IsVisContext from "../CRUD/isVisContext";

/**
 * Encerra a sessao do mesmo jeito que o menu do usuario (Header/UserMenu):
 * logout no servidor, limpeza de cookies/cache/store e volta para a tela de login correta.
 */
const useSairSistema = () => {
  const client = useApolloClient();
  const dispatch = useDispatch();
  const history = useHistory();
  const isVis = useContext(IsVisContext);
  const [logout, { loading }] = useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);

  const sair = async () => {
    try {
      const response = await logout();
      if (!response || !response.data || response.data.logout !== "LOGGEDOUT") {
        return;
      }
      document.cookie.split(";").forEach((c) => {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
      await client.cache.reset();
      await client.clearStore();
      await configureStore().persistor.flush();
      await configureStore().persistor.purge();
      dispatch(notAllowConciliador());
      if (isVis && isVis.isVisSPC === "vis") {
        history.push(Routes.loginIsVis.route);
      } else if (isVis && isVis.isVisSPC === "spc") {
        history.push(Routes.spc.route);
      } else {
        history.push(Routes.login.route);
      }
      window.location.reload();
    } catch (e) {
      console.log(e);
    }
  };

  return { sair, saindo: loading };
};

export default useSairSistema;
